import { Box, styled } from "@mui/material";

export const AppDesignSettingsWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "left",
  width: "auto"
}))

export const PreviewContainer = styled(Box)({
  position: "relative",
})

export const PreviewImageContainer = styled(Box)({
  position: "absolute",
  left: "20px",
  top: "40px",
  height: "35px",
  width: "120px",
  display: "flex"
});
